import {Directive, HostListener} from '@angular/core';
import {Router} from '@angular/router';
import {UtilityService} from "../services/utility.service";
@Directive({
    selector: '[appLinkHandler]',
    standalone : false
})

export class LinkHandlerDirective {
    constructor(
        private router: Router,
        private utilityService: UtilityService
    ) {
    }

    @HostListener('click', ['$event'])
    handleClick(event: Event) {
        const target = event.target as HTMLElement;
        console.log('Click event detected on element:', target);

        if (target.tagName !== 'A') return;

        const href = target.getAttribute('href');
        if (!href) return;

        if (href.startsWith('/')) {
            event.preventDefault();

            const linkClass = target.getAttribute('class');
            if (linkClass && linkClass === 'mss-modal') {
                this.utilityService.openPageModal(href);
            } else {
                this.router.navigateByUrl(href);
                return;
            }
        }

        if (href.startsWith('http://') || href.startsWith('https://')) {
            event.preventDefault();
            this.utilityService.openExternalLink(href);
        }
    }
}
